import {unzipSync,strFromU8} from "fflate";
import {xlsxToCsv} from "./parseXlsx";
const MAX_TEXT=8000;
export async function readAssistantFile(file){
 if(!file||file.size>4_000_000)throw new Error("Arquivo acima de 4 MB; divida o conteúdo em partes.");
 const name=String(file.name||"documento").replace(/[<>]/g,"").slice(0,100);
 const extension=name.split(".").pop().toLowerCase();
 let text="";
 if(extension==="txt"||extension==="csv"||extension==="md")text=await file.text();
 else if(extension==="xlsx"){
  if(file.size>500000)throw new Error("Planilha extensa; importe pela aba Clientes ou Produtos.");
  text=xlsxToCsv(await file.arrayBuffer());
 }else if(extension==="docx"){
  const map=unzipSync(new Uint8Array(await file.arrayBuffer()),{filter:f=>f.name==="word/document.xml"&&f.originalSize<=3_000_000});
  if(!map["word/document.xml"])throw new Error("Documento Word inválido.");
  const xml=new DOMParser().parseFromString(strFromU8(map["word/document.xml"]),"application/xml");
  text=Array.from(xml.getElementsByTagName("w:p")).map(p=>
   Array.from(p.getElementsByTagName("w:t")).map(t=>t.textContent||"").join("")).join("\n");
 }else if(extension==="pdf"){
  const pdfjs=await import("pdfjs-dist/legacy/build/pdf.mjs");
  pdfjs.GlobalWorkerOptions.workerSrc="/pdf.worker.mjs";
  const document=await pdfjs.getDocument({data:new Uint8Array(await file.arrayBuffer()),isEvalSupported:false}).promise;
  const pages=Math.min(document.numPages,12),chunks=[];
  for(let pageNumber=1;pageNumber<=pages;pageNumber++){
   const page=await document.getPage(pageNumber);
   const content=await page.getTextContent();
   chunks.push("Página "+pageNumber+": "+content.items.map(i=>i.str||"").join(" "));
   if(chunks.join("\n").length>MAX_TEXT)break;
  }
  text=chunks.join("\n");
  if(!text.trim())throw new Error("O PDF não contém texto selecionável. PDFs digitalizados precisam de OCR.");
 }else throw new Error("Formato não suportado. Use TXT, CSV, XLSX, DOCX ou PDF.");
 if(!text.trim())throw new Error("O arquivo não contém texto legível.");
 return {name,text:text.slice(0,MAX_TEXT),truncated:text.length>MAX_TEXT};
}
